// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAGJ6YbbQLOisol7gjLj5IrwffgOhac1r8",
  authDomain: "hotel-check-list.firebaseapp.com",
  projectId: "hotel-check-list",
  storageBucket: "hotel-check-list.firebasestorage.app",
  messagingSenderId: "801381488765",
  appId: "1:801381488765:web:a40627387f0e6bda207914",
  measurementId: "G-0TM6SNHBYM"
};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);

export { db, auth, analytics, storage };
